import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import BrandStory from './components/BrandStory';
import Reputation from './components/Reputation';
import ContactCTA from './components/ContactCTA';

export default function About() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = '关于我们-樱花动漫网-专为手机用户打造的免费动漫平台';
  }, []);

  const faqData = {
    mainEntity: [
      {
        '@type': 'Question',
        name: '樱花动漫网是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '樱花动漫网是一个专为手机用户打造的免费动漫在线观看平台，无需下载任何应用，通过移动设备浏览器即可随时随地畅快追番。',
        },
      },
      {
        '@type': 'Question',
        name: '樱花动漫网需要收费吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '不需要。樱花动漫网始终坚持免费策略，让每一位动漫爱好者都能无门槛地享受优质的动漫内容。',
        },
      },
      {
        '@type': 'Question',
        name: '樱花动漫网有多少动漫资源？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '樱花动漫网已积累超过5000部动漫资源，涵盖热血、冒险、恋爱、搞笑、奇幻、科幻等各个类型，且每天持续更新。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在手机上观看动漫？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '只需在手机浏览器中打开樱花动漫网，选择您喜欢的动漫即可直接在线播放，无需下载额外应用，支持横屏竖屏自由切换。',
        },
      },
    ],
  };

  return (
    <>
      <SchemaOrg
        type="WebPage"
        data={{
          name: '关于我们-樱花动漫网',
          description: '了解樱花动漫网的品牌故事、团队理念和联系方式。樱花动漫网是专为手机用户打造的免费动漫在线观看平台。',
          url: 'http://kktyvqy.cn/about',
          isPartOf: {
            '@type': 'WebSite',
            name: '樱花动漫网',
            url: 'http://kktyvqy.cn/',
          },
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: t('首页'), item: 'http://kktyvqy.cn/' },
            { '@type': 'ListItem', position: 2, name: t('关于我们') },
          ],
        }}
      />
      <SchemaOrg type="FAQPage" data={faqData} />

      <Navbar />

      <main>
        <Breadcrumb items={[{ label: t('关于我们') }]} />
        <BrandStory />
        <Reputation />
        <ContactCTA />
      </main>

      <Footer />
    </>
  );
}